import { render, staticRenderFns } from "./orderCancelHandle.vue?vue&type=template&id=c920428a&scoped=true&"
import script from "./orderCancelHandle.vue?vue&type=script&lang=js&"
export * from "./orderCancelHandle.vue?vue&type=script&lang=js&"
import style0 from "./orderCancelHandle.vue?vue&type=style&index=0&id=c920428a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c920428a",
  null
  
)

export default component.exports